import { isBoolean, isString } from 'lodash-es';
import { LogItemProps } from '../LogItemLayout';
import { useScenarioLabel, useGetCheckDisplay } from '../useUtils';
import { T, useTranslate } from '@tolgee/react';

export const Text = (props: { text: any }) => {
  return <span className="px-1">{props.text}</span>;
};

// API: https://leyan.yuque.com/czpqnb/pd/lxets1c2pzfkeqp9
export const useDetail = (data: LogItemProps['data']) => {
  const { t } = useTranslate();
  const getCheckDisplay = useGetCheckDisplay();
  const { operateType, changeField, scenarioType, changeDetail } = data;
  const scenarioLabel = useScenarioLabel(scenarioType);

  if (operateType !== 'UPDATE_TASK') return null;

  if (changeField === 'TASK_NAME') {
    return {
      before: changeDetail?.before,
      after: changeDetail?.after,
    };
  }

  if (changeField === 'TASK_FILTER_HAS_CONVERSATION') {
    // 过滤下单后在该店铺有过咨询的买家
    const text = t('aide.过滤下单后在该店铺有过咨询的买家');
    return {
      before: getCheckDisplay(changeDetail?.before, text),
      after: getCheckDisplay(changeDetail?.after, text),
    };
  }

  if (changeField === 'TASK_FILTER_AFTER_SALE_ENABLE') {
    // 售后买家开关
    const text = t('aide.售后买家');
    return {
      before: getCheckDisplay(changeDetail?.before, text),
      after: getCheckDisplay(changeDetail?.after, text),
    };
  }

  if (changeField === 'TASK_FILTER_AFTER_SALE_CONFIRM_DAYS') {
    // 售后买家-确认收天数
    return {
      before: (
        <T
          keyName="marketing.买家确认收货x天内与客服对话，视为咨询售后问题，将不会触发action"
          params={{ x: <Text text={changeDetail?.before} />, action: scenarioLabel }}
        />
      ),
      after: (
        <T
          keyName="marketing.买家确认收货x天内与客服对话，视为咨询售后问题，将不会触发action"
          params={{ x: <Text text={changeDetail?.after} />, action: scenarioLabel }}
        />
      ),
    };
  }

  if (
    changeField === 'TASK_FILTER_AFTER_SALE_OUT_OF_ORDER_ITEM' &&
    isBoolean(changeDetail?.before) &&
    isBoolean(changeDetail?.before)
  ) {
    // 买家咨询订单外商品开关
    const text = t('marketing.在上述期间，若买家咨询订单外商品，仍然可以action', {
      action: scenarioLabel,
    }) as string;
    return {
      before: getCheckDisplay(changeDetail?.before, text),
      after: getCheckDisplay(changeDetail?.after, text),
    };
  }

  if (
    changeField === 'TASK_PRAISE_TRIGGER_POINT' &&
    changeDetail?.before &&
    changeDetail?.after &&
    isString(changeDetail?.before) &&
    isString(changeDetail?.after)
  ) {
    // 催好评发送时间节点
    const praiseTriggerLabel = {
      SIGNED: t('marketing.买家签收'),
      CONFIRMED: t('marketing.买家确认收货'),
    };
    return {
      // @ts-ignore
      before: praiseTriggerLabel[changeDetail?.before],
      // @ts-ignore
      after: praiseTriggerLabel[changeDetail?.after],
    };
  }

  return null;
};
